import type { Intent, Option, UseCaseId } from '../types/content'

export const contact = {
  phoneDisplay: '1300 426 672',
  phoneHref: 'tel:1300426672',
  email: 'sales@afb.energy',
  emailHref: 'mailto:sales@afb.energy',
  street: '12 Thermal Chase',
  locality: 'Bibra Lake',
  region: 'WA',
  postcode: '6163',
  country: 'Australia',
  response: 'Response within 48 hours',
  privacyUrl: 'https://www.afb.energy/privacy-policy-2/',
  siteUrl: 'https://www.afb.energy/',
  logo: 'https://cdn.magicpatterns.com/uploads/sxWbLtJK7KjGTRFhER2ZNM/Australian-flow-batteries-logo-1.webp',
}

// News URL is inferred from the current site structure — confirm before launch.
export const navLinks = [
  { label: 'Solutions', href: '#solutions' },
  { label: 'Industries', href: '#industries' },
  { label: 'Technology', href: '#technology' },
  { label: 'Resources', href: '#resources' },
  { label: 'News', href: 'https://www.afb.energy/news/' },
  { label: 'Contact', href: '#contact' },
]

// Replace with AFB's LinkedIn company page and YouTube channel URLs.
export const socialLinks = {
  linkedin: 'https://www.linkedin.com/',
  youtube: 'https://www.youtube.com/',
}

// Only the partners shown in the current homepage "Our Partners" section.
// Each slot renders "Partner logo supplied" until the logo file is added.
export const partners: { name: string; logo: string | null }[] = [
  { name: 'Partner 1', logo: null },
  { name: 'Partner 2', logo: null },
  { name: 'Partner 3', logo: null },
  { name: 'Partner 4', logo: null },
  { name: 'Partner 5', logo: null },
]

export const useCaseOptions: Option<UseCaseId>[] = [
  { value: 'remote', label: 'Remote & off-grid power' },
  { value: 'disaster', label: 'Disaster response' },
  { value: 'agriculture', label: 'Agriculture' },
  { value: 'utilities', label: 'Utilities & microgrids' },
  { value: 'defence', label: 'Defence & critical infrastructure' },
  { value: 'other', label: 'Something else' },
]

export const intentOptions: Option<Intent>[] = [
  { value: 'assessment', label: 'A site assessment' },
  { value: 'demo-tour', label: 'A demo tour in Perth' },
  { value: 'proposal', label: 'A proposal or tender documents' },
  { value: 'general', label: 'General question' },
]

export const stateOptions: Option[] = [
  { value: 'WA', label: 'Western Australia' },
  { value: 'NT', label: 'Northern Territory' },
  { value: 'SA', label: 'South Australia' },
  { value: 'QLD', label: 'Queensland' },
  { value: 'NSW', label: 'New South Wales' },
  { value: 'ACT', label: 'Australian Capital Territory' },
  { value: 'VIC', label: 'Victoria' },
  { value: 'TAS', label: 'Tasmania' },
  { value: 'INTL', label: 'Outside Australia' },
]

export const timeframeOptions: Option[] = [
  { value: '0-3', label: 'Within 3 months' },
  { value: '3-6', label: '3–6 months' },
  { value: '6-12', label: '6–12 months' },
  { value: 'research', label: 'Researching or in a tender' },
]

export const intentMessages: Record<Intent, string> = {
  assessment: '',
  'demo-tour': "I'd like to book a demo tour at Bibra Lake.",
  proposal: "I'd like a proposal / documentation pack for a project.",
  general: '',
}
